// extracted by mini-css-extract-plugin
export default {"Label":"Label_Label__msRpd","Error":"Label_Error__Uzs+R"};